import API from '../../../../../services/api';
import { headers } from '../helpers/functionalities';

export const API_PROVEEDORES = {
    getProveedores: async (page = null, search = null) => {
        const pagination = page !== null ? '?page=' + page : '';
        const searcher = search !== null && page !== null ? '&' + search : search !== null ? '?' + search : '';
        return await API.get('/proveedores'+ pagination + searcher).then(res => res.data);
    },
    getAllProveedores: async () => {
        return await API.get('/proveedores-all').then(res => res.data);
    },
    getProveedorFicha: async (section, search = null, page, idProveedor) => {
        const pagination = '?page=' + page;
        const seccion = '&seccion=' + section;
        const searcher = search ? '&' + search : '';
        return API.get('/proveedores/' + idProveedor + pagination + seccion + searcher).then(res => res.data);
    },
    buscarProveedor: async (proveedor) => {
        return API.post('/proveedores/buscar', proveedor).then(res => res.data);
    },
    obtenerProveedorIntegracion: async (proveedor) => {
        return API.post('/proveedores/proveedor-integracion', proveedor).then(res => res.data);
    },
    newProveedor: async (proveedor) => {
        return API.post('/proveedores', proveedor).then(res => res.data);
    },
    associateProveedor: async (proveedor, name_to_associate) => {
        return API.post('/proveedores/associate', {proveedor: proveedor.id, posible: name_to_associate}).then(res => res.data);
    },
    comprasExport: async (data) => {
        return API.post('/proveedores/export', data, {responseType: 'blob'}).then(res => res.data);
    },
    comprobarProveedor: async (proveedor) => {
        return API.post('/proveedores/comprobar', proveedor).then(res => res.data);
    },
    fusionarProveedores: async (data) => {
        return API.post('/proveedores/merge', data).then(res => res.data);
    },
    updateProveedor: async (proveedor) => {
        return API.post('/proveedores/' + (proveedor instanceof FormData ? proveedor.get("id") : proveedor.id) + '/update', proveedor, (proveedor instanceof FormData ? headers : null)).then(res => res.data);
    }
}

export const API_DESCUENTOS_PROVEEDOR = {
    newDescuento: async (descuento) => {
        return API.post('/descuentos-proveedor', descuento).then(res => res.data);
    },
    updateDescuento: async (descuento) => {
        return API.put('/descuentos-proveedor/' + descuento.id, descuento).then(res => res.data);
    },
    deleteDescuento: async (idDescuento) => {
        return API.delete('/descuentos-proveedor/' + idDescuento).then(res => res.data);
    }
}

export const API_TRANSPORTISTAS_FAVORITOS_PROVEEDORES = {
    newTransportistaFav: async (descuento) => {
        return API.post('/transportistas-proveedor', descuento).then(res => res.data);
    },
    updateTransportistaFav: async (descuento) => {
        return API.put('/transportistas-proveedor/' + descuento.id, descuento).then(res => res.data);
    },
    deleteTransportistaFav: async (idDescuento) => {
        return API.delete('/transportistas-proveedor/' + idDescuento).then(res => res.data);
    }
}

export const API_ALMACENES_PROVEEDORES = {
    newAlmacen: async (almacen) => {
        return API.post('/almacenes-proveedores', almacen).then(res => res.data);
    },
    updateAlmacen: async (almacen) => {
        return API.put('/almacenes-proveedores/' + almacen.id, almacen).then(res => res.data);
    },
    deleteAlmacen: async (almacenId) => {
        return API.delete('/almacenes-proveedores/' + almacenId).then(res => res.data);
    }
}

export const API_VACACIONES_PROVEEDORES = {
    newVacaciones: async (almacen) => {
        return API.post('/vacaciones-proveedores', almacen).then(res => res.data);
    },
    updateVacaciones: async (almacen) => {
        return API.put('/vacaciones-proveedores/' + almacen.id, almacen).then(res => res.data);
    },
    deleteVacaciones: async (almacenId) => {
        return API.delete('/vacaciones-proveedores/' + almacenId).then(res => res.data);
    }
}

export const API_VALES_PROVEEDORES = {
    getVale: async (valeId) => {
        return await API.get('/vale-proveedores/' + valeId + '/download', {responseType: 'blob'}).then(res => res.data);
    },
    newVale: async (vale) => {
        return API.post('/vale-proveedores', vale, vale instanceof FormData ? headers : null).then(res => res.data);
    },
    discount: async (vale) => {
        return API.post('/vale-proveedores/' + vale.id + '/discount', vale).then(res => res.data);
    },
    updateVale: async (valeId, vale) => {
        return API.post('/vale-proveedores/' + valeId, vale, vale instanceof FormData ? headers : null).then(res => res.data);
    },
    deleteVale: async (valeId) => {
        return API.delete('/vale-proveedores/' + valeId).then(res => res.data);
    }
}